/*******************************************************************************
TRIGGER CLEAR DATA FILTER
Triggers clearing the data filter.
*******************************************************************************/

import clearFilter from './clear';

export default function triggerClearDataFilter(e) {
    const itemSelector = $(e.currentTarget).prev('input').data('items');
    clearFilter(itemSelector);
}
